/**
 * O que está escolhido no mapa. Duas formas, porque o mapa responde a duas
 * perguntas diferentes e não deve fingir que responde à mesma:
 *
 * - `concelho` — clique (ou escolha nos selects) sobre Portugal continental: temos
 *   as três horas, a ocultação e a altura do Sol, calculadas para a sede.
 * - `point` — clique em qualquer outro sítio (Espanha, França, mar): só temos a
 *   banda de ocultação por baixo. Mostrar horas aqui seria inventá-las.
 */

export interface PointSelection {
    lat: number;
    lon: number;
    /** Threshold da banda mais alta que contém o ponto, ou null se estiver fora
     *  de todas (canto sudeste da moldura, onde a ocultação cai abaixo de 90%). */
    thresholdPct: number | null;
    thresholdLabel: string | null;
    /** Nome do país sob o ponto, ou null se for mar. */
    countryName: string | null;
    /** O ponto cai dentro da faixa de totalidade. */
    inTotality: boolean;
}

export type Selection = { kind: 'concelho'; code: string } | { kind: 'point'; point: PointSelection } | null;

/** "38,717°N · 9,139°O" — o formato do painel. Vírgula decimal e "O" de Oeste,
 *  não "W", porque o texto é pt-PT. */
export function formatCoords(lat: number, lon: number): string {
    const fmt = (v: number) => Math.abs(v).toFixed(3).replace('.', ',');
    return `${fmt(lat)}°${lat >= 0 ? 'N' : 'S'} · ${fmt(lon)}°${lon >= 0 ? 'E' : 'O'}`;
}
